module.exports = __webpack_public_path__ + "static/img/scam.11450eda.jpg";